import request from "@/CommonDP/utils/request";
import { getToken } from "@/CommonDP/utils";
import { getContextPath } from "@/CommonDP/mongeView/utils";
export default {
  addPermission(params) {
    return request.post(`/admin/permission/addPermission`, params).then((res) => res);
  },
  queryPermissionTree(id, appCode = "") {
    return request.get(`/admin/permission/queryPermissionTree?businessType=${id}&appCode=${appCode}`).then((res) => res);
  },
  updatePermission(params) {
    return request.post(`/admin/permission/updatePermission`, params).then((res) => res);
  },
  updatePermissionByIsUse(id, isUse) {
    return request.get(`/admin/permission/updatePermissionByIsUse?id=${id}&isUse=${isUse}`).then((res) => res);
  },
  deletePermission(id) {
    return request.get(`/admin/permission/deletePermission?id=${id}`).then((res) => res);
  },
  getGroup() {
    return request.get(`/permission/appGroup/get`).then((res) => res);
  },
  getResourceIcon(id) {
    return request.get("/sys-resource-icon/getIconByResourceId?resourceId=" + id).then((res) => res);
  },
  getResourceActiveIconUrl(resourceId) {
    return location.origin + getContextPath() + "/sys-resource-icon/getActiveIcon?resourceId=" + resourceId + "&token=" + getToken();
  },
  getResourceInActiveIconUrl(resourceId) {
    return location.origin + getContextPath() + "/sys-resource-icon/getInactiveIcon?resourceId=" + resourceId + "&token=" + getToken();
  },
  singleDeletePermission(params) {
    return request.post(`/permission/deletePermission`, params).then((res) => res);
  },
  batchDeletePermission(params) {
    return request.post(`/permission/batchDelete`, params).then((res) => res);
  }
};
